import getFeature from "@template/helpers/getFeature";
import getFeatureVariables from "@template/helpers/getFeatureVariables";

export async function getVariantKey() {
  const STC_NAV_LINKS = "stc-nav-links";
  const feature = await getFeature(STC_NAV_LINKS);

  if (feature?.isEnabled()) {
    const { variantKey } = await getFeatureVariables(STC_NAV_LINKS);
    return variantKey;
  }

  return undefined;
}
